import * as userPreferencesAction from '../actions/user-preferences.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface UserPreferencesState {
    preferences: Array<any>;
    loading: boolean;
    loaded: boolean;
    addOrUpdateSuccess: boolean;
    error: any;
}

const initialState = {
    preferences: null,
    loading: false,
    loaded: false,
    addOrUpdateSuccess: null,
    error: null,
};

export const userPreferencesReducer = (state = initialState, action) => {
    switch (action.type) {
        case userPreferencesAction.GET_USER_PREFERENCES:
            return {
                ...state,
                error: null,
                loading: true,
                loaded: state.loaded
            };
        case userPreferencesAction.GET_USER_PREFERENCES_SUCCESS:
            const preference = action.payload.columns;
            const preferences = state.preferences;
            preferences[action.payload.viewName] = preference;
            return {
                ...state,
                preferences: preferences,
                error: null,
                loading: false,
                loaded: true,
            };
        case userPreferencesAction.GET_USER_PREFERENCES_FAIL:
            return {
                ...state,
                preferences: null,
                error: action.payload,
                loading: false,
                loaded: false
            };
        case userPreferencesAction.ADD_OR_UPDATE_USER_PREFERENCES_SUCCESS:
            return {
                ...state,
                preferences: action.payload,
                error: null,
                loading: state.loading,
                loaded: state.loaded,
                addOrUpdateSuccess: true
            };
        case userPreferencesAction.ADD_OR_UPDATE_USER_PREFERENCES_FAIL:
            return {
                ...state,
                error: action.payload,
                addOrUpdateSuccess: false
            };

        case userPreferencesAction.RESET_USER_PREFERENCES_CRUD:
            return {
                ...state,
                error: null,
                addOrUpdateSuccess: null,
            };
        case userPreferencesAction.CLEAR_USER_PREFERENCES_LIST:
            return {
                ...state,
                error: null,
                preferences: null,
                loading: false,
                loaded: false
            };
        default:
            return state;
    }
};

export const getUserPreferencesState = createFeatureSelector<UserPreferencesState>('userPreferencesReducer');

export const getUserPreferences = (state: UserPreferencesState) => state.preferences;
export const getUserPreferencesLoaded = (state: UserPreferencesState) => state.loaded;
export const getUserPreferencesAddOrUpdateStatus = (state: UserPreferencesState) => state.addOrUpdateSuccess;
